export default __webpack_public_path__ + "static/media/myaccount.cf6f112b.png";